export enum Role {
  DistrictAdmin = 'districtAdmin',
  SchoolAdmin = 'schoolAdmin',
  Teacher = 'teacher',
  Student = 'student',
}
